/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationSucceededV1
 */
export interface SDKEventAuthenticationSucceededV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    person_id: string;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    success_authn_method: FactorMethod;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    authenticated_methods: Array<FactorMethod>;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationSucceededV1
     */
    handle?: PersonHandle;
}

/**
 * Check if a given object implements the SDKEventAuthenticationSucceededV1 interface.
 */
export function instanceOfSDKEventAuthenticationSucceededV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "success_authn_method" in value;
    isInstance = isInstance && "authenticated_methods" in value;

    return isInstance;
}

export function SDKEventAuthenticationSucceededV1FromJSON(json: any): SDKEventAuthenticationSucceededV1 {
    return SDKEventAuthenticationSucceededV1FromJSONTyped(json, false);
}

export function SDKEventAuthenticationSucceededV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationSucceededV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
        'success_authn_method': FactorMethodFromJSON(json['success_authn_method']),
        'authenticated_methods': ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
    };
}

export function SDKEventAuthenticationSucceededV1ToJSON(value?: SDKEventAuthenticationSucceededV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
        'person_id': value.person_id,
        'success_authn_method': FactorMethodToJSON(value.success_authn_method),
        'authenticated_methods': ((value.authenticated_methods as Array<any>).map(FactorMethodToJSON)),
        'handle': PersonHandleToJSON(value.handle),
    };
}

